// Lazy loaded in component - no static imports needed

import { useExports } from './useExports';
import { itemsExportColumns } from '../data/exportData';
import { UsePurchaseExportProps } from '../types';
import { useState } from 'react';
import { showWarningSnackbar } from '../../../components/snackBar/snakbar';

export const useItemExport = ({ startDate, endDate, selectedArray }: UsePurchaseExportProps) => {
  const [status, setStatus] = useState({
    active: true,
    inactive: false,
  });

  const exportHook = useExports({
    columns: itemsExportColumns,
    action: 'ITEMSEXPORT',
    startDate,
    endDate,
    options: { selectedArray, status: status.active && status.inactive ? 'Both' : status.active ? 'Active' : 'Inactive' },
  });
  console.log(
    { selectedArray, status: status.active && status.inactive ? 'Both' : status.active ? 'Active' : 'Inactive' },
    "selectedArray, status: status.active && status.inactive ? 'Both' : status.active ? 'Active' : 'Inactive'"
  );

  const handleExport = () => {
    if (status.active === false && status.inactive === false) {
      showWarningSnackbar('Please check atleast one status (Active or Inactive)');
      return;
    }
    exportHook.handleExport();
  };
  const hasSelectedItems = selectedArray !== undefined && Array.isArray(selectedArray) && selectedArray.length > 0;
  // const hasFilters = filters !== undefined && filters !== null && Object.keys(filters).length > 0;
  const isDateChangeable = !hasSelectedItems;

  return {
    ...exportHook,
    handleExport,
    setStatus,
    status,
    isDateChangeable,
    startDate,
    endDate,
    selectedArray,
  };
};
